"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeographyV1StateStateNutsDistrictCitiesGetPartnerTypeEnum = exports.GeographyV1StateOtherCitiesCountByStreetsStateNameLimitGetPartnerTypeEnum = exports.GeographyV1StateAllNutsGetPartnerTypeEnum = exports.GeographyV1RegionNutsStateNutsGetPartnerTypeEnum = exports.GeographyV1RegionNameStateNameDistrictNameGetPartnerTypeEnum = exports.GeographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGetPartnerTypeEnum = exports.GeographyV1GetPlaceNamesZipcodeGetPartnerTypeEnum = exports.GeographyV1GetOtherZipcodesPlaceZipcodeGetPartnerTypeEnum = exports.GeographyV1FindAllPlacesGetPartnerTypeEnum = exports.GeographyV1DistrictRegionDistrictNutsGetPartnerTypeEnum = exports.GeographyV1AllZipcodesGetPartnerTypeEnum = exports.GeographyApi = exports.GeographyApiFactory = exports.GeographyApiFp = exports.GeographyApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
const common_1 = require("../common");
const base_1 = require("../base");
const GeographyApiAxiosParamCreator = function (configuration) {
    return {
        geographyV1AllZipcodesGet: async (partnerType, options = {}) => {
            const localVarPath = `/geography/v1/all-zipcodes`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1DistrictGetStateDistrictNutsGet: async (districtNuts, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1DistrictGetStateDistrictNutsGet', 'districtNuts', districtNuts);
            const localVarPath = `/geography/v1/district/get-state/{districtNuts}`
                .replace(`{${"districtNuts"}}`, encodeURIComponent(String(districtNuts)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1DistrictRegionDistrictNutsGet: async (districtNuts, partnerType, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1DistrictRegionDistrictNutsGet', 'districtNuts', districtNuts);
            const localVarPath = `/geography/v1/district/region/{districtNuts}`
                .replace(`{${"districtNuts"}}`, encodeURIComponent(String(districtNuts)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1DistrictsWithZipcodesGet: async (options = {}) => {
            const localVarPath = `/geography/v1/districts-with-zipcodes`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1FilterPostalCodesPost: async (postalCodesDto, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1FilterPostalCodesPost', 'postalCodesDto', postalCodesDto);
            const localVarPath = `/geography/v1/filter-postal-codes`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postalCodesDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1FindAllPlacesGet: async (partnerType, options = {}) => {
            const localVarPath = `/geography/v1/find-all-places`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1GetGroupedStringGet: async (string, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1GetGroupedStringGet', 'string', string);
            const localVarPath = `/geography/v1/get-grouped/{string}`
                .replace(`{${"string"}}`, encodeURIComponent(String(string)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1GetOtherZipcodesPlaceZipcodeGet: async (place, zipcode, partnerType, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1GetOtherZipcodesPlaceZipcodeGet', 'place', place);
            (0, common_1.assertParamExists)('geographyV1GetOtherZipcodesPlaceZipcodeGet', 'zipcode', zipcode);
            const localVarPath = `/geography/v1/get-other-zipcodes/{place}/{zipcode}`
                .replace(`{${"place"}}`, encodeURIComponent(String(place)))
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1GetPlaceInformationByZipcodePost: async (postalCodesDto, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1GetPlaceInformationByZipcodePost', 'postalCodesDto', postalCodesDto);
            const localVarPath = `/geography/v1/get-place-information-by-zipcode`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postalCodesDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1GetPlaceNamesZipcodeGet: async (zipcode, partnerType, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1GetPlaceNamesZipcodeGet', 'zipcode', zipcode);
            const localVarPath = `/geography/v1/get-place-names/{zipcode}`
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet: async (place, zipcode, limit, partnerType, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet', 'place', place);
            (0, common_1.assertParamExists)('geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet', 'zipcode', zipcode);
            (0, common_1.assertParamExists)('geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet', 'limit', limit);
            const localVarPath = `/geography/v1/get-places-in-municipality/{place}/{zipcode}/{limit}`
                .replace(`{${"place"}}`, encodeURIComponent(String(place)))
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)))
                .replace(`{${"limit"}}`, encodeURIComponent(String(limit)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1GetStreetNameZipcodeStreetGet: async (zipcode, street, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1GetStreetNameZipcodeStreetGet', 'zipcode', zipcode);
            (0, common_1.assertParamExists)('geographyV1GetStreetNameZipcodeStreetGet', 'street', street);
            const localVarPath = `/geography/v1/get-street-name/{zipcode}/{street}`
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)))
                .replace(`{${"street"}}`, encodeURIComponent(String(street)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1GetZipcodesByNutscodeNutsCodeGet: async (nutsCode, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1GetZipcodesByNutscodeNutsCodeGet', 'nutsCode', nutsCode);
            const localVarPath = `/geography/v1/get-zipcodes-by-nutscode/{nutsCode}`
                .replace(`{${"nutsCode"}}`, encodeURIComponent(String(nutsCode)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1GetZipcodesByPlaceNameStringGet: async (string, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1GetZipcodesByPlaceNameStringGet', 'string', string);
            const localVarPath = `/geography/v1/get-zipcodes-by-place-name/{string}`
                .replace(`{${"string"}}`, encodeURIComponent(String(string)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1HealthCheckGet: async (options = {}) => {
            const localVarPath = `/geography/v1/health-check`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1LocationGetcityZipcodeGet: async (zipcode, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1LocationGetcityZipcodeGet', 'zipcode', zipcode);
            const localVarPath = `/geography/v1/location/getcity/{zipcode}`
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1LocationZipcodeExistGet: async (zipcode, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1LocationZipcodeExistGet', 'zipcode', zipcode);
            const localVarPath = `/geography/v1/location/{zipcode}/exist`
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1RegionNameStateNameDistrictNameGet: async (stateName, districtName, partnerType, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1RegionNameStateNameDistrictNameGet', 'stateName', stateName);
            (0, common_1.assertParamExists)('geographyV1RegionNameStateNameDistrictNameGet', 'districtName', districtName);
            const localVarPath = `/geography/v1/region/name/{stateName}/{districtName}`
                .replace(`{${"stateName"}}`, encodeURIComponent(String(stateName)))
                .replace(`{${"districtName"}}`, encodeURIComponent(String(districtName)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1RegionNameStateNameGet: async (stateName, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1RegionNameStateNameGet', 'stateName', stateName);
            const localVarPath = `/geography/v1/region/name/{stateName}`
                .replace(`{${"stateName"}}`, encodeURIComponent(String(stateName)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1RegionNutsStateNutsDistrictNutsGet: async (stateNuts, districtNuts, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1RegionNutsStateNutsDistrictNutsGet', 'stateNuts', stateNuts);
            (0, common_1.assertParamExists)('geographyV1RegionNutsStateNutsDistrictNutsGet', 'districtNuts', districtNuts);
            const localVarPath = `/geography/v1/region/nuts/{stateNuts}/{districtNuts}`
                .replace(`{${"stateNuts"}}`, encodeURIComponent(String(stateNuts)))
                .replace(`{${"districtNuts"}}`, encodeURIComponent(String(districtNuts)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1RegionNutsStateNutsGet: async (stateNuts, partnerType, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1RegionNutsStateNutsGet', 'stateNuts', stateNuts);
            const localVarPath = `/geography/v1/region/nuts/{stateNuts}`
                .replace(`{${"stateNuts"}}`, encodeURIComponent(String(stateNuts)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1StateAllNutsGet: async (partnerType, options = {}) => {
            const localVarPath = `/geography/v1/state/all-nuts`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1StateOtherCitiesCountByStreetsStateNameLimitGet: async (stateName, limit, partnerType, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1StateOtherCitiesCountByStreetsStateNameLimitGet', 'stateName', stateName);
            (0, common_1.assertParamExists)('geographyV1StateOtherCitiesCountByStreetsStateNameLimitGet', 'limit', limit);
            const localVarPath = `/geography/v1/state/other-cities-count-by-streets/{stateName}/{limit}`
                .replace(`{${"stateName"}}`, encodeURIComponent(String(stateName)))
                .replace(`{${"limit"}}`, encodeURIComponent(String(limit)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1StateStateNutsCitiesGet: async (stateNuts, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1StateStateNutsCitiesGet', 'stateNuts', stateNuts);
            const localVarPath = `/geography/v1/state/{stateNuts}/cities`
                .replace(`{${"stateNuts"}}`, encodeURIComponent(String(stateNuts)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        geographyV1StateStateNutsDistrictCitiesGet: async (stateNuts, partnerType, options = {}) => {
            (0, common_1.assertParamExists)('geographyV1StateStateNutsDistrictCitiesGet', 'stateNuts', stateNuts);
            const localVarPath = `/geography/v1/state/{stateNuts}/district-cities`
                .replace(`{${"stateNuts"}}`, encodeURIComponent(String(stateNuts)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partnerType !== undefined) {
                localVarQueryParameter['partnerType'] = partnerType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.GeographyApiAxiosParamCreator = GeographyApiAxiosParamCreator;
const GeographyApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.GeographyApiAxiosParamCreator)(configuration);
    return {
        async geographyV1AllZipcodesGet(partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1AllZipcodesGet(partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1AllZipcodesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1DistrictGetStateDistrictNutsGet(districtNuts, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1DistrictGetStateDistrictNutsGet(districtNuts, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1DistrictGetStateDistrictNutsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1DistrictRegionDistrictNutsGet(districtNuts, partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1DistrictRegionDistrictNutsGet(districtNuts, partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1DistrictRegionDistrictNutsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1DistrictsWithZipcodesGet(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1DistrictsWithZipcodesGet(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1DistrictsWithZipcodesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1FilterPostalCodesPost(postalCodesDto, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1FilterPostalCodesPost(postalCodesDto, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1FilterPostalCodesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1FindAllPlacesGet(partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1FindAllPlacesGet(partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1FindAllPlacesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1GetGroupedStringGet(string, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1GetGroupedStringGet(string, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1GetGroupedStringGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1GetOtherZipcodesPlaceZipcodeGet(place, zipcode, partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1GetOtherZipcodesPlaceZipcodeGet(place, zipcode, partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1GetOtherZipcodesPlaceZipcodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1GetPlaceInformationByZipcodePost(postalCodesDto, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1GetPlaceInformationByZipcodePost(postalCodesDto, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1GetPlaceInformationByZipcodePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1GetPlaceNamesZipcodeGet(zipcode, partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1GetPlaceNamesZipcodeGet(zipcode, partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1GetPlaceNamesZipcodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet(place, zipcode, limit, partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet(place, zipcode, limit, partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1GetStreetNameZipcodeStreetGet(zipcode, street, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1GetStreetNameZipcodeStreetGet(zipcode, street, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1GetStreetNameZipcodeStreetGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1GetZipcodesByNutscodeNutsCodeGet(nutsCode, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1GetZipcodesByNutscodeNutsCodeGet(nutsCode, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1GetZipcodesByNutscodeNutsCodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1GetZipcodesByPlaceNameStringGet(string, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1GetZipcodesByPlaceNameStringGet(string, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1GetZipcodesByPlaceNameStringGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1HealthCheckGet(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1HealthCheckGet(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1HealthCheckGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1LocationGetcityZipcodeGet(zipcode, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1LocationGetcityZipcodeGet(zipcode, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1LocationGetcityZipcodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1LocationZipcodeExistGet(zipcode, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1LocationZipcodeExistGet(zipcode, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1LocationZipcodeExistGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1RegionNameStateNameDistrictNameGet(stateName, districtName, partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1RegionNameStateNameDistrictNameGet(stateName, districtName, partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1RegionNameStateNameDistrictNameGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1RegionNameStateNameGet(stateName, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1RegionNameStateNameGet(stateName, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1RegionNameStateNameGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1RegionNutsStateNutsDistrictNutsGet(stateNuts, districtNuts, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1RegionNutsStateNutsDistrictNutsGet(stateNuts, districtNuts, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1RegionNutsStateNutsDistrictNutsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1RegionNutsStateNutsGet(stateNuts, partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1RegionNutsStateNutsGet(stateNuts, partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1RegionNutsStateNutsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1StateAllNutsGet(partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1StateAllNutsGet(partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1StateAllNutsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1StateOtherCitiesCountByStreetsStateNameLimitGet(stateName, limit, partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1StateOtherCitiesCountByStreetsStateNameLimitGet(stateName, limit, partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1StateOtherCitiesCountByStreetsStateNameLimitGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1StateStateNutsCitiesGet(stateNuts, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1StateStateNutsCitiesGet(stateNuts, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1StateStateNutsCitiesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async geographyV1StateStateNutsDistrictCitiesGet(stateNuts, partnerType, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.geographyV1StateStateNutsDistrictCitiesGet(stateNuts, partnerType, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GeographyApi.geographyV1StateStateNutsDistrictCitiesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.GeographyApiFp = GeographyApiFp;
const GeographyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.GeographyApiFp)(configuration);
    return {
        geographyV1AllZipcodesGet(partnerType, options) {
            return localVarFp.geographyV1AllZipcodesGet(partnerType, options).then((request) => request(axios, basePath));
        },
        geographyV1DistrictGetStateDistrictNutsGet(districtNuts, options) {
            return localVarFp.geographyV1DistrictGetStateDistrictNutsGet(districtNuts, options).then((request) => request(axios, basePath));
        },
        geographyV1DistrictRegionDistrictNutsGet(districtNuts, partnerType, options) {
            return localVarFp.geographyV1DistrictRegionDistrictNutsGet(districtNuts, partnerType, options).then((request) => request(axios, basePath));
        },
        geographyV1DistrictsWithZipcodesGet(options) {
            return localVarFp.geographyV1DistrictsWithZipcodesGet(options).then((request) => request(axios, basePath));
        },
        geographyV1FilterPostalCodesPost(postalCodesDto, options) {
            return localVarFp.geographyV1FilterPostalCodesPost(postalCodesDto, options).then((request) => request(axios, basePath));
        },
        geographyV1FindAllPlacesGet(partnerType, options) {
            return localVarFp.geographyV1FindAllPlacesGet(partnerType, options).then((request) => request(axios, basePath));
        },
        geographyV1GetGroupedStringGet(string, options) {
            return localVarFp.geographyV1GetGroupedStringGet(string, options).then((request) => request(axios, basePath));
        },
        geographyV1GetOtherZipcodesPlaceZipcodeGet(place, zipcode, partnerType, options) {
            return localVarFp.geographyV1GetOtherZipcodesPlaceZipcodeGet(place, zipcode, partnerType, options).then((request) => request(axios, basePath));
        },
        geographyV1GetPlaceInformationByZipcodePost(postalCodesDto, options) {
            return localVarFp.geographyV1GetPlaceInformationByZipcodePost(postalCodesDto, options).then((request) => request(axios, basePath));
        },
        geographyV1GetPlaceNamesZipcodeGet(zipcode, partnerType, options) {
            return localVarFp.geographyV1GetPlaceNamesZipcodeGet(zipcode, partnerType, options).then((request) => request(axios, basePath));
        },
        geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet(place, zipcode, limit, partnerType, options) {
            return localVarFp.geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet(place, zipcode, limit, partnerType, options).then((request) => request(axios, basePath));
        },
        geographyV1GetStreetNameZipcodeStreetGet(zipcode, street, options) {
            return localVarFp.geographyV1GetStreetNameZipcodeStreetGet(zipcode, street, options).then((request) => request(axios, basePath));
        },
        geographyV1GetZipcodesByNutscodeNutsCodeGet(nutsCode, options) {
            return localVarFp.geographyV1GetZipcodesByNutscodeNutsCodeGet(nutsCode, options).then((request) => request(axios, basePath));
        },
        geographyV1GetZipcodesByPlaceNameStringGet(string, options) {
            return localVarFp.geographyV1GetZipcodesByPlaceNameStringGet(string, options).then((request) => request(axios, basePath));
        },
        geographyV1HealthCheckGet(options) {
            return localVarFp.geographyV1HealthCheckGet(options).then((request) => request(axios, basePath));
        },
        geographyV1LocationGetcityZipcodeGet(zipcode, options) {
            return localVarFp.geographyV1LocationGetcityZipcodeGet(zipcode, options).then((request) => request(axios, basePath));
        },
        geographyV1LocationZipcodeExistGet(zipcode, options) {
            return localVarFp.geographyV1LocationZipcodeExistGet(zipcode, options).then((request) => request(axios, basePath));
        },
        geographyV1RegionNameStateNameDistrictNameGet(stateName, districtName, partnerType, options) {
            return localVarFp.geographyV1RegionNameStateNameDistrictNameGet(stateName, districtName, partnerType, options).then((request) => request(axios, basePath));
        },
        geographyV1RegionNameStateNameGet(stateName, options) {
            return localVarFp.geographyV1RegionNameStateNameGet(stateName, options).then((request) => request(axios, basePath));
        },
        geographyV1RegionNutsStateNutsDistrictNutsGet(stateNuts, districtNuts, options) {
            return localVarFp.geographyV1RegionNutsStateNutsDistrictNutsGet(stateNuts, districtNuts, options).then((request) => request(axios, basePath));
        },
        geographyV1RegionNutsStateNutsGet(stateNuts, partnerType, options) {
            return localVarFp.geographyV1RegionNutsStateNutsGet(stateNuts, partnerType, options).then((request) => request(axios, basePath));
        },
        geographyV1StateAllNutsGet(partnerType, options) {
            return localVarFp.geographyV1StateAllNutsGet(partnerType, options).then((request) => request(axios, basePath));
        },
        geographyV1StateOtherCitiesCountByStreetsStateNameLimitGet(stateName, limit, partnerType, options) {
            return localVarFp.geographyV1StateOtherCitiesCountByStreetsStateNameLimitGet(stateName, limit, partnerType, options).then((request) => request(axios, basePath));
        },
        geographyV1StateStateNutsCitiesGet(stateNuts, options) {
            return localVarFp.geographyV1StateStateNutsCitiesGet(stateNuts, options).then((request) => request(axios, basePath));
        },
        geographyV1StateStateNutsDistrictCitiesGet(stateNuts, partnerType, options) {
            return localVarFp.geographyV1StateStateNutsDistrictCitiesGet(stateNuts, partnerType, options).then((request) => request(axios, basePath));
        },
    };
};
exports.GeographyApiFactory = GeographyApiFactory;
class GeographyApi extends base_1.BaseAPI {
    geographyV1AllZipcodesGet(partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1AllZipcodesGet(partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1DistrictGetStateDistrictNutsGet(districtNuts, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1DistrictGetStateDistrictNutsGet(districtNuts, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1DistrictRegionDistrictNutsGet(districtNuts, partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1DistrictRegionDistrictNutsGet(districtNuts, partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1DistrictsWithZipcodesGet(options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1DistrictsWithZipcodesGet(options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1FilterPostalCodesPost(postalCodesDto, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1FilterPostalCodesPost(postalCodesDto, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1FindAllPlacesGet(partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1FindAllPlacesGet(partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1GetGroupedStringGet(string, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1GetGroupedStringGet(string, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1GetOtherZipcodesPlaceZipcodeGet(place, zipcode, partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1GetOtherZipcodesPlaceZipcodeGet(place, zipcode, partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1GetPlaceInformationByZipcodePost(postalCodesDto, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1GetPlaceInformationByZipcodePost(postalCodesDto, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1GetPlaceNamesZipcodeGet(zipcode, partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1GetPlaceNamesZipcodeGet(zipcode, partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet(place, zipcode, limit, partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGet(place, zipcode, limit, partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1GetStreetNameZipcodeStreetGet(zipcode, street, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1GetStreetNameZipcodeStreetGet(zipcode, street, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1GetZipcodesByNutscodeNutsCodeGet(nutsCode, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1GetZipcodesByNutscodeNutsCodeGet(nutsCode, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1GetZipcodesByPlaceNameStringGet(string, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1GetZipcodesByPlaceNameStringGet(string, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1HealthCheckGet(options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1HealthCheckGet(options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1LocationGetcityZipcodeGet(zipcode, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1LocationGetcityZipcodeGet(zipcode, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1LocationZipcodeExistGet(zipcode, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1LocationZipcodeExistGet(zipcode, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1RegionNameStateNameDistrictNameGet(stateName, districtName, partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1RegionNameStateNameDistrictNameGet(stateName, districtName, partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1RegionNameStateNameGet(stateName, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1RegionNameStateNameGet(stateName, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1RegionNutsStateNutsDistrictNutsGet(stateNuts, districtNuts, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1RegionNutsStateNutsDistrictNutsGet(stateNuts, districtNuts, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1RegionNutsStateNutsGet(stateNuts, partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1RegionNutsStateNutsGet(stateNuts, partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1StateAllNutsGet(partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1StateAllNutsGet(partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1StateOtherCitiesCountByStreetsStateNameLimitGet(stateName, limit, partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1StateOtherCitiesCountByStreetsStateNameLimitGet(stateName, limit, partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1StateStateNutsCitiesGet(stateNuts, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1StateStateNutsCitiesGet(stateNuts, options).then((request) => request(this.axios, this.basePath));
    }
    geographyV1StateStateNutsDistrictCitiesGet(stateNuts, partnerType, options) {
        return (0, exports.GeographyApiFp)(this.configuration).geographyV1StateStateNutsDistrictCitiesGet(stateNuts, partnerType, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.GeographyApi = GeographyApi;
exports.GeographyV1AllZipcodesGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
exports.GeographyV1DistrictRegionDistrictNutsGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
exports.GeographyV1FindAllPlacesGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
exports.GeographyV1GetOtherZipcodesPlaceZipcodeGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
exports.GeographyV1GetPlaceNamesZipcodeGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
exports.GeographyV1GetPlacesInMunicipalityPlaceZipcodeLimitGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
exports.GeographyV1RegionNameStateNameDistrictNameGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
exports.GeographyV1RegionNutsStateNutsGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
exports.GeographyV1StateAllNutsGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
exports.GeographyV1StateOtherCitiesCountByStreetsStateNameLimitGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
exports.GeographyV1StateStateNutsDistrictCitiesGetPartnerTypeEnum = {
    PARTNER: 'PARTNER',
    PARTNER_PELLET: 'PARTNER_PELLET'
};
//# sourceMappingURL=geography-api.js.map